import { render } from "./Map.vue?vue&type=template&id=e4bcbcc2&scoped=true"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import "./Map.vue?vue&type=style&index=0&id=e4bcbcc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bcbcc2"]])

export default __exports__